module.exports = __webpack_public_path__ + "img/jameson-2.03f2473b.png";